import type { SignInCodeChannel } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getSignInCodeChannels } from '../../../../../shared/features/session/session.api';

export type SignInCodeChannelsState = { status: 'loading' } | { status: 'loaded'; channels: SignInCodeChannel[] } | { status: 'error' };

/** The channels a sign-in code can go by on this deployment right now, for the Sign-in codes card. */
export function useSignInCodeChannels(): SignInCodeChannelsState {
  const [state, setState] = useState<SignInCodeChannelsState>({ status: 'loading' });

  useEffect(() => {
    let isCurrent = true;
    getSignInCodeChannels()
      .then(({ channels }) => isCurrent && setState({ status: 'loaded', channels }))
      .catch(() => isCurrent && setState({ status: 'error' }));
    return () => {
      isCurrent = false;
    };
  }, []);

  return state;
}
